import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../UserContext";
import { useNavigate } from "react-router-dom";
import Footer from "../Footer";
import AdminNav from "../Navbars/AdminNav";
import axios from "axios";
import { toast } from "react-toastify";
import countryList from 'react-select-country-list';
import "./ManageRewards.css";
import axiosInstance from "./axiosInstance";

function ManageRewards() {
  const [rewards, setRewards] = useState([]);
  const [formData, setFormData] = useState({
    giftname: "",
    description: "",
    pointscost: "",
    country: "Pakistan",
    TermsConditions: "",
    giftpicture: null
  });
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);
  const [editingId, setEditingId] = useState(null);
  const [countryOptions, setCountryOptions] = useState([]);

  const { isAdmin, setUserRole, setUserInfo, userInfo } = useContext(UserContext);
  const navigate = useNavigate();

  useEffect(() => {
    fetchUserInfo();
    fetchRewards();
    // Initialize country list
    setCountryOptions(countryList().getData());
  }, []);

  const fetchUserInfo = async () => {
    try {
      const response = await fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}`, {
        credentials: "include",
      });
      const data = await response.json();
      setUserInfo(data);
      if (data?.usertype) {
        setUserRole(data.usertype);
      }
    } catch (error) {
      console.log("Error in fetchUserInfo:", error);
    }
  };

  const formatDate = (dateString) => {
    const options = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const fetchRewards = () => {
    axiosInstance.get("/getGifts")
      .then((response) => {
        setRewards(response.data);
      })
      .catch((error) => {
        console.error("Error fetching rewards:", error);
        toast.error("Failed to load rewards", {
          position: toast.POSITION.TOP_RIGHT,
        });
      });
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value
    });
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setFormData({ ...formData, giftpicture: file });
      const reader = new FileReader();
      reader.onloadend = () => setPreview(reader.result); // For local preview only
      reader.readAsDataURL(file);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const formDataToSend = new FormData();
      formDataToSend.append("giftname", formData.giftname);
      formDataToSend.append("description", formData.description);
      formDataToSend.append("pointscost", formData.pointscost);
      formDataToSend.append("country", formData.country);
      formDataToSend.append("TermsConditions", formData.TermsConditions);
      if (formData.giftpicture) {
        formDataToSend.append("giftpicture", formData.giftpicture); // Send the File object
      }

      if (editingId) {
        formDataToSend.append("Gift_id", editingId);
        await axiosInstance.post("/updateGift", formDataToSend, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        toast.success("Reward updated successfully", { position: toast.POSITION.TOP_RIGHT });
      } else {
        await axiosInstance.post("/saveGift", formDataToSend, {
          headers: { "Content-Type": "multipart/form-data" }
        });
        toast.success("Reward added successfully", { position: toast.POSITION.TOP_RIGHT });
      }

      resetForm();
      fetchRewards();
    } catch (error) {
      console.error("Error saving reward:", error);
      toast.error("Failed to save reward", { position: toast.POSITION.TOP_RIGHT });
    } finally {
      setLoading(false);
    }
  };
  const handleEdit = (reward) => {
    setEditingId(reward.Gift_id);
    setFormData({
      giftname: reward.giftname,
      description: reward.description,
      pointscost: reward.pointscost,
      country: reward.country,
      TermsConditions: reward.TermsConditions,
      giftpicture: null
    });
    setPreview(reward.giftpicture ? `data:image/jpeg;base64,${reward.giftpicture}` : null);
  };

  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this reward?")) {
      try {
        await axiosInstance.post("/deleteGift", { Gift_id: id });
        toast.success("Reward deleted successfully", {
          position: toast.POSITION.TOP_RIGHT,
        });
        fetchRewards();
      } catch (error) {
        console.error("Error deleting reward:", error);
        toast.error("Failed to delete reward", {
          position: toast.POSITION.TOP_RIGHT,
        });
      }
    }
  };



  const resetForm = () => {
    setFormData({
      giftname: "",
      description: "",
      pointscost: "",
      country: "Pakistan",
      TermsConditions: "",
      giftpicture: null
    });
    setPreview(null);
    setEditingId(null);
  };

  const onLogout = () => {
    fetch(`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/logout`, {
      credentials: "include",
      method: "POST",
    })
      .then(() => {
        navigate("/");
      })
      .catch((error) => {
        console.error("Logout failed:", error);
      });
    setUserInfo(null);
    setUserRole("guest");
  };

  const username = userInfo?.username;

  return (
    <>
      {username && isAdmin && <AdminNav username={username} onLogout={onLogout} />}

      <div className="manage-rewards-container">
        <h2 className="page-title">Manage Rewards</h2>

        <div className="rewards-content">
          {/* Form Section */}
          <div className="rewards-form">
            <h3>{editingId ? "Edit Reward" : "Add New Reward"}</h3>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Reward Image</label>
                <div className="file-upload">
                  <input
                    type="file"
                    id="giftpicture"
                    onChange={handleFileChange}
                    accept="image/*"
                  />
                  <label htmlFor="giftpicture" className="upload-btn">
                    Choose Image
                  </label>
                </div>
                {preview && (
                  <div className="image-preview">
                    <img src={preview} alt="Reward Preview" />
                  </div>
                )}
              </div>

              <div className="form-group">
                <label>Reward Name</label>
                <input
                  type="text"
                  name="giftname"
                  value={formData.giftname}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form-group">
                <label>Description</label>
                <textarea
                  name="description"
                  value={formData.description}
                  onChange={handleInputChange}
                  required
                  rows="3"
                ></textarea>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Points Cost</label>
                  <input
                    type="number"
                    name="pointscost"
                    value={formData.pointscost}
                    onChange={handleInputChange}
                    required
                    min="1"
                  />
                </div>

                <div className="form-group">
                  <label>Country</label>
                  <select
                    name="country"
                    value={formData.country}
                    onChange={handleInputChange}
                    required
                  >
                    {countryOptions.map((country) => (
                      <option key={country.value} value={country.label}>
                        {country.label}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="form-group">
                <label>Terms & Conditions</label>
                <textarea
                  name="TermsConditions"
                  value={formData.TermsConditions}
                  onChange={handleInputChange}
                  required
                  rows="4"
                ></textarea>
              </div>

              <div className="form-actions">
                <button type="submit" className="submit-btn" disabled={loading}>
                  {loading ? "Processing..." : (editingId ? "Update Reward" : "Add Reward")}
                </button>
                {editingId && (
                  <button type="button" className="cancel-btn" onClick={resetForm}>
                    Cancel
                  </button>
                )}
              </div>
            </form>
          </div>

          {/* Rewards List Section */}
          <div className="rewards-list">
            <h3>Existing Rewards</h3>

            <div className="table-container">
              <table>
                <thead>
                  <tr>
                    <th>Image</th>
                    <th>Name</th>
                    <th>Points</th>
                    <th>Country</th>
                    <th>Created Date</th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {rewards.map((reward) => (
                    <tr key={reward.Gift_id}>
                      <td>
                        {reward.giftpicture && (
                          <img
                            src={`${(process.env.REACT_APP_API_BASE_URL || process.env.REACT_APP_LOCAL_SERVER_API)}/${reward.giftpicture}`} // Adjust path based on your server setup
                            alt={reward.giftname}
                            className="reward-img"
                            onError={(e) => {
                              console.log("Image failed to load:", e);
                              e.target.style.display = 'none';
                            }}
                          />
                        )}
                      </td>
                      <td>{reward.giftname}</td>
                      <td>{reward.pointscost}</td>
                      <td>{reward.country}</td>
                      <td>{formatDate(reward.creationdate)}</td>
                      <td>
                        <button
                          className="edit-btn"
                          onClick={() => handleEdit(reward)}
                        >
                          Edit
                        </button>
                        <button
                          className="delete-btn"
                          onClick={() => handleDelete(reward.Gift_id)}
                        >
                          Delete
                        </button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
}

export default ManageRewards;